module.exports = __webpack_public_path__ + "images/emoji/office.dfbfdca45793b8fe8cc0.png";